import {FC, useState} from "react";
import {LearnCategory} from "../../../lib/src/api/repositories/learn-repository";
import {useApiCall} from "../../../lib/src/api";
import {config} from "../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";
import {Autocomplete} from "../../../lib/src/components/form/auto-complete/Autocomplete";

export const MoveLearnCategoryModal: FC<{ category: LearnCategory, categories: LearnCategory[], reload: () => void }> = (props) => {
  const {learn} = useApiCall(config)
  const [selectedCategory, setSelectedCategory] = useState<string>('-')
  const categoryMap = [
    ['-', 'Selecteer een categorie om naar te verplaatsen'],
    ['geen', 'Verplaats naar hoofdcategorie'],
    ...props.categories.map((category) => [category.id, category.name])
  ];


  const save = async () => {
    if (selectedCategory !== '-') {
      await learn.editCategory(props.category.id, props.category.name, selectedCategory, props.category.is_pinned_category)
      props.reload()
    }
  }

  return <>
    <div className={'h-48'}>
      <Autocomplete label={'Categorieën'} options={Object.fromEntries(categoryMap)} value={selectedCategory} onChange={setSelectedCategory} />
    </div>

    <ModalFooter text={'Verplaats'} onSubmit={save} />
  </>
}